export const backdropMotionProps = (animationsDisabled) => ({
  initial: animationsDisabled ? false : { opacity: 0 },
  animate: animationsDisabled ? false : { opacity: 1 },
  exit: animationsDisabled ? false : { opacity: 0 },
  transition: { duration: 0.1 },
});

export const leftHandDrawerMotionProps = (animationsDisabled) => ({
  initial: animationsDisabled ? false : { y: "90vh" },
  animate: animationsDisabled ? false : { y: 0 },
  exit: animationsDisabled ? false : { y: "90vh" },
  transition: { type: "none", duration: 0.25 },
});

export const FadeInOut = (animationsDisabled, duration = 0.2) => ({
  initial: animationsDisabled ? false : { opacity: 0 },
  animate: animationsDisabled ? false : { opacity: 1 },
  exit: animationsDisabled ? false : { opacity: 0 },
  transition: { duration },
});

export const examCreatorListMotionProps = (
  animationsDisabled,
  scale = 0.98
) => ({
  initial: animationsDisabled
    ? false
    : { opacity: 0, transform: `scaleY(${scale}) scaleX(0.99)` },
  animate: animationsDisabled
    ? false
    : { opacity: 1, transform: `scaleY(1) scaleX(1)` },
  exit: animationsDisabled
    ? false
    : { opacity: 0, transform: `scaleY(${scale}) scaleX(0.99)` },
  transition: { duration: 0.2 },
});

export const modalPopupMotionProps = (animationsDisabled) => ({
  initial: animationsDisabled
    ? false
    : {
        y: 30,
        opacity: 0,
        translateX: "-50%",
        translateY: "-50%",
        scale: 0.9,
      },
  animate: animationsDisabled
    ? false
    : {
        y: 0,
        opacity: 1,
        translateX: "-50%",
        translateY: "-50%",
        scale: 1,
      },
  exit: animationsDisabled
    ? false
    : {
        y: 30,
        opacity: 0,
        translateX: "-50%",
        translateY: "-50%",
        scale: 0.9,
      },
  transition: { duration: 0.2 },
});

export const moreOptionsPopupMotionProps = (animationsDisabled) => ({
  initial: animationsDisabled
    ? false
    : { opacity: 0, transform: "scale(0.95) translate(5%, -5%)" },
  animate: animationsDisabled
    ? false
    : { opacity: 1, transform: "scale(1) translate(0%, 0%)" },
  exit: animationsDisabled
    ? false
    : { opacity: 0, transform: "scale(0.95) translate(5%, -5%)" },
  transition: { duration: 0.15, ease: "easeOut" },
});
